var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "gray-area", attrs: { id: "content" } },
    [
      _c("div", { staticClass: "container" }, [
        _c(
          "div",
          { staticClass: "row" },
          [
            _c("sdr-breadcrumbs", {
              attrs: { active_item: "fifth", module: _vm.modulo },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "form",
            {
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                  return _vm.onSubmit($event)
                },
              },
            },
            [
              _c(
                "div",
                {
                  staticClass: "col-sms-6 col-sm-8 col-md-9",
                  attrs: { id: "main" },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "tab-container",
                      attrs: { id: "flight-features" },
                    },
                    [
                      _c("ul", { staticClass: "tabs" }, [
                        _c("li", { staticClass: "active" }, [
                          _c(
                            "a",
                            {
                              attrs: {
                                href: "#flight-details",
                                "data-toggle": "tab",
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.tab_flightdetails[_vm.getCurrentLocale]
                                ) + "XXX"
                              ),
                            ]
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "tab-content" }, [
                        _c(
                          "div",
                          {
                            staticClass: "tab-pane fade in active",
                            attrs: { id: "flight-details" },
                          },
                          [
                            _vm.get_RebookingUsersSearchDataGetRebookingKey
                              .idTicketOutwards.length > 0
                              ? _c(
                                  "div",
                                  [
                                    _c("h2", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.tab_header_flightdetailsoutward[
                                            _vm.getCurrentLocale
                                          ]
                                        ) + ":"
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "sdr-rebooking-bookingno-flightdetails",
                                      {
                                        attrs: {
                                          flight:
                                            _vm
                                              .get_RebookingGetRebookingKeyResults
                                              .outwardFlight,
                                          flightdirection: "outward",
                                          modulo: _vm.modulo,
                                          mode: _vm.mode,
                                          whichcall: "getrebookingkey",
                                        },
                                      }
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.get_RebookingUsersSearchDataGetRebookingKey
                              .idTicketReturn.length > 0
                              ? _c(
                                  "div",
                                  [
                                    _c("br"),
                                    _c("hr", {
                                      staticStyle: {
                                        "border-top": "1px solid #fdb714",
                                      },
                                    }),
                                    _c("br"),
                                    _vm._v(" "),
                                    _c("h2", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.tab_header_flightdetailsreturn[
                                            _vm.getCurrentLocale
                                          ]
                                        ) + ":"
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "sdr-rebooking-bookingno-flightdetails",
                                      {
                                        attrs: {
                                          flight:
                                            _vm
                                              .get_RebookingGetRebookingKeyResults
                                              .inboundFlight,
                                          flightdirection: "return",
                                          modulo: _vm.modulo,
                                          mode: _vm.mode,
                                          whichcall: "getrebookingkey",
                                        },
                                      }
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c("br"),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "btn-large full-width totalbutton",
                                staticStyle: {
                                  cursor: "initial",
                                  outline: "none !important",
                                  "outline-style": "none !important",
                                  background: "#FDB714",
                                },
                                attrs: { type: "button" },
                              },
                              [
                                _vm._v(
                                  "\n                                    " +
                                    _vm._s(
                                      _vm._f("rndAmntRUAFWZ")(
                                        Number(
                                          _vm.get_RebookingGetRebookingTicketsTotal
                                        )
                                      )
                                    ) +
                                    "\n                                    "
                                ),
                                _c("br"),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticStyle: { "font-size": "0.5em" } },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.tincludedtaxes[_vm.getCurrentLocale]
                                      )
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("div", { staticClass: "booking-information sdr-box" }, [
                    _c("h2", [
                      _vm._v(_vm._s(_vm.payment[_vm.getCurrentLocale]) + ":"),
                    ]),
                    _vm._v(" "),
                    _c("dl", { staticClass: "term-description" }, [
                      _c("dt", [
                        _vm._v(
                          _vm._s(_vm.payment_firstname[_vm.getCurrentLocale]) +
                            ":"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("dd", [
                        _vm._v(
                          _vm._s(
                            _vm.getBookingProcessBookingObject.customer
                              .firstName
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c("dt", [
                        _vm._v(
                          _vm._s(_vm.payment_lastname[_vm.getCurrentLocale]) +
                            ":"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("dd", [
                        _vm._v(
                          _vm._s(
                            _vm.getBookingProcessBookingObject.customer.lastName
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c("dt", [
                        _vm._v(
                          _vm._s(_vm.payment_email[_vm.getCurrentLocale]) + ":"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("dd", [
                        _vm._v(
                          _vm._s(
                            _vm.getBookingProcessBookingObject.customer.email
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c("dt", [
                        _vm._v(
                          _vm._s(_vm.payment_phone[_vm.getCurrentLocale]) + ":"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("dd", [
                        _vm._v(
                          _vm._s(
                            _vm.getBookingProcessBookingObject.customer.phone
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c("dt", [
                        _vm._v(
                          _vm._s(_vm.payment_address[_vm.getCurrentLocale]) +
                            ":"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("dd", [
                        _vm._v(
                          _vm._s(
                            _vm.getBookingProcessBookingObject.customer.address
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c("dt", [
                        _vm._v(
                          _vm._s(_vm.payment_zipcode[_vm.getCurrentLocale]) +
                            ":"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("dd", [
                        _vm._v(
                          _vm._s(
                            _vm.getBookingProcessBookingObject.customer.zipCode
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c("dt", [
                        _vm._v(
                          _vm._s(_vm.payment_city[_vm.getCurrentLocale]) + ":"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("dd", [
                        _vm._v(
                          _vm._s(
                            _vm.getBookingProcessBookingObject.customer.city
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c("dt", [
                        _vm._v(
                          _vm._s(
                            _vm.payment_countrycode[_vm.getCurrentLocale]
                          ) + ":"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("dd", [
                        _vm._v(
                          _vm._s(
                            _vm.getBookingProcessBookingObject.customer
                              .countryCode
                          )
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("hr"),
                    _vm._v(" "),
                    _c("h2", [
                      _vm._v(
                        _vm._s(_vm.paymentmethod[_vm.getCurrentLocale]) + ":"
                      ),
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(_vm._s(_vm.forsecurity[_vm.getCurrentLocale])),
                    ]),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(" "),
                    _vm.getBookingProcessBookingObject.payment.type !== "OO"
                      ? _c("p", { staticClass: "red-color" }, [
                          _vm._v(
                            "\n                            " +
                              _vm._s(
                                _vm.paymentismadeby[_vm.getCurrentLocale]
                              ) +
                              "\n                            " +
                              _vm._s(
                                _vm.getBookingProcessBookingObject.payment
                                  .ccPayment !== undefined
                                  ? _vm.creditcard[_vm.getCurrentLocale]
                                  : null
                              ) +
                              "\n                            " +
                              _vm._s(
                                _vm.getBookingProcessBookingObject.payment
                                  .ddPayment !== undefined
                                  ? _vm.debit[_vm.getCurrentLocale]
                                  : null
                              ) +
                              "\n                            " +
                              _vm._s(
                                _vm.getBookingProcessBookingObject.payment
                                  .type === "CS"
                                  ? _vm.cashpayment[_vm.getCurrentLocale]
                                  : null
                              ) +
                              "\n                        ."
                          ),
                        ])
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _vm.dd2faRequiredForFlow && _vm.isDdPayment
                    ? _c("div", { staticClass: "booking-section sdr-box" }, [
                        _c(
                          "div",
                          {
                            staticClass: "dd-2fa-banner",
                            class: {
                              "dd-2fa-banner--done": _vm.dd2faLocallyComplete,
                            },
                          },
                          [
                            _c("div", { staticClass: "dd-2fa-banner__body" }, [
                              _c(
                                "span",
                                { staticClass: "dd-2fa-banner__step" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.dd2faStepLabel[_vm.getCurrentLocale]
                                    )
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "dd-2fa-banner__content" },
                                [
                                  !_vm.dd2faLocallyComplete
                                    ? _c("i", { staticClass: "fa fa-shield" })
                                    : _c("i", {
                                        staticClass: "fa fa-check-circle",
                                      }),
                                  _vm._v(" "),
                                  _c("div", [
                                    _c("strong", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.dd2faActionTitle[
                                            _vm.getCurrentLocale
                                          ]
                                        )
                                      ),
                                    ]),
                                  ]),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "dd-2fa-banner__action" },
                              [
                                !_vm.dd2faLocallyComplete
                                  ? _c(
                                      "button",
                                      {
                                        staticClass:
                                          "button btn-medium uppercase dd-2fa-open-btn",
                                        attrs: { type: "button" },
                                        on: {
                                          click: function ($event) {
                                            $event.preventDefault()
                                            return _vm.openDd2faModal($event)
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(
                                              _vm.dd2faOpenModal[
                                                _vm.getCurrentLocale
                                              ]
                                            ) +
                                            "\n                                "
                                        ),
                                      ]
                                    )
                                  : _c("span", { staticClass: "dd-2fa-done" }, [
                                      _c("i", {
                                        staticClass: "soap-icon-check-1",
                                      }),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.dd2faDone[_vm.getCurrentLocale]
                                          ) +
                                          "\n                                "
                                      ),
                                    ]),
                              ]
                            ),
                          ]
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "booking-section sdr-box dd-2fa-checkboxes-wrap",
                      class: {
                        "dd-2fa-checkboxes-wrap--locked":
                          _vm.areCheckboxesLocked,
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "container shortcode travel-ideas" },
                        [
                          _c(
                            "h2",
                            {
                              staticClass: "idea-title red-color",
                              staticStyle: { "margin-bottom": "15px" },
                            },
                            [
                              _vm._m(1),
                              _vm._v(
                                "\n                                " +
                                  _vm._s(
                                    _vm.pleaseconfirm[_vm.getCurrentLocale]
                                  ) +
                                  ":\n                            "
                              ),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "form-group" },
                        [
                          _c(
                            "p-check",
                            {
                              staticClass: "p-svg p-round p-pulse",
                              attrs: {
                                color: "success",
                                value: "ABB",
                                id: "check",
                              },
                              model: {
                                value: _vm.checkedBoxes,
                                callback: function ($$v) {
                                  _vm.checkedBoxes = $$v
                                },
                                expression: "checkedBoxes",
                              },
                            },
                            [
                              _c(
                                "svg",
                                {
                                  staticClass: "svg svg-icon",
                                  attrs: {
                                    slot: "extra",
                                    viewBox: "0 0 20 20",
                                  },
                                  slot: "extra",
                                },
                                [
                                  _c("path", {
                                    staticStyle: {
                                      stroke: "white",
                                      fill: "white",
                                    },
                                    attrs: {
                                      d: "M7.629,14.566c0.125,0.125,0.291,0.188,0.456,0.188c0.164,0,0.329-0.062,0.456-0.188l8.219-8.221c0.252-0.252,0.252-0.659,0-0.911c-0.252-0.252-0.659-0.252-0.911,0l-7.764,7.763L4.152,9.267c-0.252-0.251-0.66-0.251-0.911,0c-0.252,0.252-0.252,0.66,0,0.911L7.629,14.566z",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" \n                            "),
                          _c(
                            "a",
                            {
                              attrs: { href: "#" },
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  _vm.call_getwebcomponent("ABB")
                                },
                              },
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "xskin-color",
                                  staticStyle: { "font-size": "1.0833em" },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.form_confirmabb_1[
                                        _vm.getCurrentLocale
                                      ]
                                    )
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(" "),
                          _c(
                            "p-check",
                            {
                              staticClass: "p-svg p-round p-pulse",
                              attrs: {
                                color: "success",
                                value: "AGB",
                                id: "check",
                              },
                              model: {
                                value: _vm.checkedBoxes,
                                callback: function ($$v) {
                                  _vm.checkedBoxes = $$v
                                },
                                expression: "checkedBoxes",
                              },
                            },
                            [
                              _c(
                                "svg",
                                {
                                  staticClass: "svg svg-icon",
                                  attrs: {
                                    slot: "extra",
                                    viewBox: "0 0 20 20",
                                  },
                                  slot: "extra",
                                },
                                [
                                  _c("path", {
                                    staticStyle: {
                                      stroke: "white",
                                      fill: "white",
                                    },
                                    attrs: {
                                      d: "M7.629,14.566c0.125,0.125,0.291,0.188,0.456,0.188c0.164,0,0.329-0.062,0.456-0.188l8.219-8.221c0.252-0.252,0.252-0.659,0-0.911c-0.252-0.252-0.659-0.252-0.911,0l-7.764,7.763L4.152,9.267c-0.252-0.251-0.66-0.251-0.911,0c-0.252,0.252-0.252,0.66,0,0.911L7.629,14.566z",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" \n                            "),
                          _c(
                            "a",
                            {
                              attrs: { href: "#" },
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  _vm.call_getwebcomponent("AGB")
                                },
                              },
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "xskin-color",
                                  staticStyle: { "font-size": "1.0833em" },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.form_confirmagb_1[
                                        _vm.getCurrentLocale
                                      ]
                                    )
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(" "),
                          _c(
                            "p-check",
                            {
                              staticClass: "p-svg p-round p-pulse",
                              attrs: {
                                color: "success",
                                value: "PCP",
                                id: "check",
                              },
                              model: {
                                value: _vm.checkedBoxes,
                                callback: function ($$v) {
                                  _vm.checkedBoxes = $$v
                                },
                                expression: "checkedBoxes",
                              },
                            },
                            [
                              _c(
                                "svg",
                                {
                                  staticClass: "svg svg-icon",
                                  attrs: {
                                    slot: "extra",
                                    viewBox: "0 0 20 20",
                                  },
                                  slot: "extra",
                                },
                                [
                                  _c("path", {
                                    staticStyle: {
                                      stroke: "white",
                                      fill: "white",
                                    },
                                    attrs: {
                                      d: "M7.629,14.566c0.125,0.125,0.291,0.188,0.456,0.188c0.164,0,0.329-0.062,0.456-0.188l8.219-8.221c0.252-0.252,0.252-0.659,0-0.911c-0.252-0.252-0.659-0.252-0.911,0l-7.764,7.763L4.152,9.267c-0.252-0.251-0.66-0.251-0.911,0c-0.252,0.252-0.252,0.66,0,0.911L7.629,14.566z",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" \n                            "),
                          _c(
                            "a",
                            {
                              attrs: { href: "#" },
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  _vm.call_getwebcomponent("PCP")
                                },
                              },
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "xskin-color",
                                  staticStyle: { "font-size": "1.0833em" },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.form_confirmdangerous_1[
                                        _vm.getCurrentLocale
                                      ]
                                    )
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(" "),
                          _c(
                            "p-check",
                            {
                              staticClass: "p-svg p-round p-pulse",
                              attrs: {
                                color: "success",
                                value: "PRIVACY",
                                id: "check",
                              },
                              model: {
                                value: _vm.checkedBoxes,
                                callback: function ($$v) {
                                  _vm.checkedBoxes = $$v
                                },
                                expression: "checkedBoxes",
                              },
                            },
                            [
                              _c(
                                "svg",
                                {
                                  staticClass: "svg svg-icon",
                                  attrs: {
                                    slot: "extra",
                                    viewBox: "0 0 20 20",
                                  },
                                  slot: "extra",
                                },
                                [
                                  _c("path", {
                                    staticStyle: {
                                      stroke: "white",
                                      fill: "white",
                                    },
                                    attrs: {
                                      d: "M7.629,14.566c0.125,0.125,0.291,0.188,0.456,0.188c0.164,0,0.329-0.062,0.456-0.188l8.219-8.221c0.252-0.252,0.252-0.659,0-0.911c-0.252-0.252-0.659-0.252-0.911,0l-7.764,7.763L4.152,9.267c-0.252-0.251-0.66-0.251-0.911,0c-0.252,0.252-0.252,0.66,0,0.911L7.629,14.566z",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" \n                            "),
                          _c(
                            "a",
                            {
                              attrs: { href: "#" },
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  _vm.call_getwebcomponent("PCPE")
                                },
                              },
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "xskin-color",
                                  staticStyle: { "font-size": "1.0833em" },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.form_confirmprivacy_1[
                                        _vm.getCurrentLocale
                                      ]
                                    )
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(" "),
                          _c(
                            "p-check",
                            {
                              staticClass: "p-svg p-round p-pulse",
                              attrs: {
                                color: "success",
                                value: "ADDITIONAL",
                                id: "check",
                              },
                              model: {
                                value: _vm.checkedBoxes,
                                callback: function ($$v) {
                                  _vm.checkedBoxes = $$v
                                },
                                expression: "checkedBoxes",
                              },
                            },
                            [
                              _c(
                                "svg",
                                {
                                  staticClass: "svg svg-icon",
                                  attrs: {
                                    slot: "extra",
                                    viewBox: "0 0 20 20",
                                  },
                                  slot: "extra",
                                },
                                [
                                  _c("path", {
                                    staticStyle: {
                                      stroke: "white",
                                      fill: "white",
                                    },
                                    attrs: {
                                      d: "M7.629,14.566c0.125,0.125,0.291,0.188,0.456,0.188c0.164,0,0.329-0.062,0.456-0.188l8.219-8.221c0.252-0.252,0.252-0.659,0-0.911c-0.252-0.252-0.659-0.252-0.911,0l-7.764,7.763L4.152,9.267c-0.252-0.251-0.66-0.251-0.911,0c-0.252,0.252-0.252,0.66,0,0.911L7.629,14.566z",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" \n                            "),
                          _c(
                            "a",
                            {
                              attrs: {
                                href: "/infos-additional-services/#/additional-services",
                                target: "_new",
                              },
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "xskin-color",
                                  staticStyle: { "font-size": "1.0833em" },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.form_confirmadditional_1[
                                        _vm.getCurrentLocale
                                      ]
                                    )
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.areCheckboxesLocked
                        ? _c(
                            "div",
                            {
                              staticClass: "dd-2fa-checkboxes-lock-overlay",
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  return _vm.openDd2faModal($event)
                                },
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "dd-2fa-checkboxes-lock-message",
                                },
                                [
                                  _c("i", { staticClass: "fa fa-lock" }),
                                  _vm._v(" "),
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.dd2faLockTitle[_vm.getCurrentLocale]
                                      )
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.dd2faLockHint[_vm.getCurrentLocale]
                                      )
                                    ),
                                  ]),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.getFlagBookingOverviewIsReadyForProcess === true
                    ? _c(
                        "button",
                        {
                          staticClass:
                            "btn-large icon-check uppercase full-width sundairrebooking icon-check4",
                          attrs: { type: "submit" },
                        },
                        [_vm._v(_vm._s(_vm.proceed[_vm.getCurrentLocale]))]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.getFlagBookingOverviewIsReadyForProcess !== true
                    ? _c(
                        "a",
                        {
                          staticClass:
                            "button btn-large uppercase full-width silver",
                        },
                        [_vm._v(_vm._s(_vm.proceed[_vm.getCurrentLocale]))]
                      )
                    : _vm._e(),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "sidebar col-sms-6 col-sm-4 col-md-3" },
            [_c("sdr-contact-box")],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            name: "size-modal2",
            transition: "nice-modal-fade",
            classes: "demo-modal-class",
            "min-width": 200,
            "min-height": 200,
            "pivot-y": 0.5,
            adaptive: true,
            scrollable: true,
            reset: true,
            xwidth: "40%",
            height: "auto",
          },
          on: {
            "before-open": _vm.beforeOpen,
            opened: _vm.opened,
            closed: _vm.closed,
            "before-close": _vm.beforeClose,
          },
        },
        [
          _c("div", { staticClass: "size-modal2-content" }, [
            _c("h2", [_vm._v(_vm._s(_vm.webcomponenttype))]),
            _vm._v(" "),
            _vm.sections.length > 1
              ? _c(
                  "span",
                  _vm._l(_vm.sections, function (section, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticClass: "toggle-container box",
                        staticStyle: { "margin-bottom": "0px" },
                        attrs: { id: "accordion1" },
                      },
                      [
                        _c("div", { staticClass: "panel style1" }, [
                          _c("h4", { staticClass: "panel-title" }, [
                            _c(
                              "a",
                              {
                                staticClass: "collapsed",
                                attrs: {
                                  href: "#acc1_" + index,
                                  "data-toggle": "collapse",
                                  "data-parent": "#accordion1",
                                },
                              },
                              [_vm._v(_vm._s(section.title))]
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "panel-collapse collapse",
                              attrs: { id: "acc1_" + index },
                            },
                            [
                              _c("div", { staticClass: "panel-content" }, [
                                _c("span", {
                                  domProps: {
                                    innerHTML: _vm._s(section.content),
                                  },
                                }),
                              ]),
                            ]
                          ),
                        ]),
                      ]
                    )
                  })
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.sections.length === 1
              ? _c("span", [
                  _c("div", { staticClass: "panel style1" }, [
                    _c("span", {
                      domProps: { innerHTML: _vm._s(_vm.sections[0].content) },
                    }),
                  ]),
                ])
              : _vm._e(),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            name: "wirecard-modal",
            transition: "nice-modal-fade",
            classes: "demo-modal-class",
            "min-width": 1000,
            "min-height": 550,
            "pivot-y": 0.5,
            adaptive: true,
            scrollable: true,
            reset: true,
            height: "auto",
            clickToClose: false,
          },
          on: {
            "before-open": _vm.beforeOpenWirecardModal,
            opened: _vm.openedWirecardModal,
            closed: _vm.closedWirecardModal,
            "before-close": _vm.beforeCloseWirecardModal,
          },
        },
        [
          _c("div", { staticClass: "size-modal2-content" }, [
            _c("h2", [_vm._v("3D Secure")]),
            _vm._v(" "),
            _c("iframe", {
              attrs: {
                name: "output_frame",
                id: "output_frame",
                width: "100%",
                height: "550",
              },
            }),
            _vm._v(" "),
            _c(
              "form",
              {
                ref: "hiddenForm",
                attrs: {
                  name: "downloadForm",
                  id: "downloadForm",
                  action: _vm.AcsUrl,
                  method: "POST",
                  target: "output_frame",
                },
              },
              [
                _c("input", {
                  attrs: { type: "hidden", name: "PaReq" },
                  domProps: { value: _vm.PaReq },
                }),
                _vm._v(" "),
                _c("input", {
                  attrs: { type: "hidden", name: "TermUrl" },
                  domProps: { value: _vm.TermUrl },
                }),
                _vm._v(" "),
                _c("input", {
                  attrs: { type: "hidden", name: "MD", value: "" },
                }),
              ]
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("sdr-dd-2fa-modal", {
        on: { "dd-2fa-confirmed": _vm.onDd2faConfirmed },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "container shortcode travel-ideas" }, [
      _c(
        "h1",
        { staticClass: "idea-title", staticStyle: { "margin-bottom": "20px" } },
        [
          _c("span", { staticClass: "index" }, [
            _c("i", { staticClass: "soap-icon-arrow-right circle" }),
          ]),
          _vm._v("\n                    XXX\n                "),
        ]
      ),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "span",
      { staticClass: "index", staticStyle: { background: "#D13E47" } },
      [_c("i", { staticClass: "soap-icon-notice circle" })]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }